export class WorkSpaceAccessToken {
  private readonly _accessToken: string | null;

  constructor(props: { accessToken: string }) {
    this._accessToken = props.accessToken;
  }

  get accessToken(): string | null {
    if (!this._accessToken || this._accessToken === "") {
      return null;
    }
    return this._accessToken;
  }
}
